@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    padding: 24px;
    background-color: var(--white);
    border-radius: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 10px;
    margin-right: 10px;
    height: 129px;
    gap: 20px;
    @include breakpoints.desktop {
        display: block;
        overflow: auto;
        margin-top: 15px;
        padding: 0px;
        width: auto;
        height: auto;
        gap: 0;
        background-color: var(--canvas-tan);
    }
}

.headerTopRow {
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 42px;
    @include breakpoints.desktop {
        display: flex;
        align-items: center;
        gap: 12px;
    }
}

.container {
    display: block;
    @include breakpoints.desktop {        
        margin: 10px 6% 60px;
        display: block;
        overflow: auto;
    }
}

.containerNew {
    display: block;
    width: 100%;
    @include breakpoints.desktop {        
        max-width: calc(var(--max-desktop-width) + (2 * var(--card-gutter-width)));
        margin: 0 auto;
        display: block;
    }
}

.headerImage {
    float: none;
    width: 42px;
    min-width: 42px;
    height: 42px;
    position: relative;
    @include breakpoints.desktop {
        float: none;
        width: 56px;
        min-width: 56px;
        height: 56px;
    }
}

.headerText {
    font-style: normal;
    font-weight: 400;
    display: flex;
    align-items: center;
    letter-spacing: 0.12em;
    text-transform: none;
    color: var(--brand-indigo);
    float: none;
    font-size: 32px;
    line-height: 100%;
    margin-right: 0;
    font-family: typography.$font-serif;
    white-space: nowrap;
    @include breakpoints.desktop {
        float: none;
        text-transform: none;
        margin-top: 0;
        margin-right: 0;
        font-weight: 400;
        font-style: normal;
        font-size: 32px;
        line-height: 100%;
        font-family: typography.$font-serif;
    }
}

.imageCircle {
    width: 42px;
    height: 42px;
    @include breakpoints.desktop {
        width: 56px;
        height: 56px;
    }
}

.imageTick {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 18px;
    transform: translate(-50%, -50%);
    @include breakpoints.desktop {
        width: 38px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

.content {    
    display: block;
    overflow: auto;
    overflow-x: hidden;
    @include breakpoints.desktop {
        margin-top: 0px;
        overflow: initial;
    }
    @include breakpoints.desktop-medium {
        overflow: initial;
    }
    @include breakpoints.desktop-large {
        overflow: initial;
    }
}

.contentBox {
    background: var(--white);
    box-shadow: none;
    padding: 0px;
    height: 150px;
    float: left;
    margin: 0px;
    width: 100%;
    height: auto;
    @include breakpoints.desktop {
        height: 150px;
        width: 46%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
      @include breakpoints.desktop-medium {
        height: 150px;
        width: 47%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
      @include breakpoints.desktop-large {
        height: 150px;
        width: 47%;
        margin: 15px;
        border-radius: 4px;
        background: var(--gray-05);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }
}

.line {
    width: 100%;
    height: 0px;
    border: 1px solid var(--gray-06);
    display: none;
    overflow: auto;
    @include breakpoints.desktop {
        display: block;
    }
}

.customButtonV2 {
    button {
        border: 2px solid var(--blue-01);
        width: 80%;
        letter-spacing: 0.12em;
        font-size: 20px;
        background-color: var(--brand-indigo);
        border-radius: 100px;
        text-transform: none;
        color: var(--white);
        margin-left: 40px;
        @include breakpoints.desktop {
            font-size: 1.125rem;
            width: 100%;
            margin-left: 0px;
        }
    }
}

.borderDivider {
    display: block;
    overflow: hidden;
    @include breakpoints.desktop {
        display: none;
    }
}

.buttonContainer {
    button {
        border: 2px solid var(--blue-01);
        width: 90%;
        letter-spacing: 0.12em;
        font-size: 20px;
        @include breakpoints.desktop {
            width: 25%;
            font-size: 1.125rem;
        }
    }
}

.wantAnother {
    padding: 10px;
    font-family: typography.$font-mont;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    text-align: center;
    vertical-align: middle;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 0%;
    text-decoration-skip-ink: auto;
}

.footer {
    display: block;
    overflow: auto;
    text-align: center;
    background-color: var(--white);
}

.footerDivider{
    margin-left: 75px;
    margin-right: 75px;
    margin-top: 20px;
    height: 1px;
    border: 0;
    background-color: var(--blue-01-at-30);
    @include breakpoints.desktop {
        margin: 0px;
        visibility: hidden;
    }
}

.footerDividerCustom{
    margin-left: 75px;
    margin-right: 75px;
    margin-top: 20px;
    height: 1px;
    border: 0;
    background-color: #0033664D;
    @include breakpoints.desktop {
        margin: 0px;
        visibility: hidden;
    }
}

.saveDisk {
    margin-right: 5px;
    margin-top: -5px;
}
.confirmContainer {
    font-size: 16px;
    padding: 0px 10px;
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0.32px;
    text-align: center;
    vertical-align: middle;
    width: 90%;
    margin-left: 20px;
    @include breakpoints.desktop {
        font-size: 16px;
        padding: 0px;
        width: 100%;
        margin-right: 0px;
        margin-left: 0px;
    }
}


.contentLeft {
    width: 15%;
    float: left;
    .avatar {
        margin-left: 0px;
        @include breakpoints.desktop {
            margin-left: 8px;
        }
    }
    @include breakpoints.desktop {
        width: 20%;
    }
    @include breakpoints.desktop-medium {
        width: 15%;
    }
    @include breakpoints.desktop-large {
        width: 15%;
    }
  }
  
.contentRight {
    width: 80%;
    float: left;
    margin-left: 12px;
    @include breakpoints.desktop {
        width:80%;
        margin-left: 0px;
    }
}

.avatar3Heads {
    margin-left: -20px;
    @include breakpoints.desktop {
        margin-left: -10px;
    }
}
.doctorPadding {
    padding: 20px 25px !important;
    @include breakpoints.desktop {
        padding: 20px !important;
    }
    @include breakpoints.desktop-medium {
        padding: 20px 25px !important;
    }
    @include breakpoints.desktop-large {
        padding: 20px 25px !important;
    }
}

.doctorName {
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0.12em;
    text-transform: none;
    color: var(--brand-indigo);
    padding: 10px 0px;
    font-family: typography.$font-serif;
    font-style: normal;
    line-height: 140%;
    letter-spacing: 0%;
    vertical-align: middle;

    @include breakpoints.desktop {
        font-size: 30px;
        line-height: 100%;
    }
    @include breakpoints.desktop-medium {
        font-size: 32px;
    }
    @include breakpoints.desktop-large {
        font-size: 32px;
    }
}

.timeSlot {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--brand-indigo);
    display: none;
    font-family: typography.$font-serif;
    font-style: normal;
    letter-spacing: 0%;
    vertical-align: middle;

    @include breakpoints.desktop {
        display: block;
        font-size: 30px;
        line-height: 100%;
    }
    @include breakpoints.desktop-medium {
        display: block;
        font-size: 32px;
        line-height: 150%;
    }
    @include breakpoints.desktop-large {
        display: block;
        font-size: 32px;
        line-height: 150%;
    }
}
.timeSlotMobile {
    float: none;
    text-align: center;
    text-transform: uppercase;
    color: var(--brand-indigo);
    display: block;
    font-family: typography.$font-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0.32px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 0 0 6px;
    margin: 0;

    @include breakpoints.desktop {
        display: none;
    }
}
.officeImg {
    width: 40px;
    height: 40px;
    margin-left: -5px;
    margin-top: 30px;
    @include breakpoints.desktop {
        width: 73px;
        height: 73px;
        margin-top: 0px;
    }
}
.officeName {
    font-size: 24px;
    line-height: 140%;
    letter-spacing: 0.02em;
    text-transform: none;
    color: var(--brand-indigo);
    font-family: typography.$font-serif;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0%;
    vertical-align: middle;

    @include breakpoints.desktop {
        font-size: 32px;
        line-height: 150%;
        letter-spacing: 0.12em;
    }
}

.officeAddress {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0%;
    font-family: typography.$font-mont;
    font-style: normal;
    letter-spacing: 0%;
    vertical-align: middle;
    color: var(--brand-indigo);

    @include breakpoints.desktop {
        font-style: normal;
        font-size: 20px;
    }
}

.patientMobile {
    padding: 10px 25px !important;
    @include breakpoints.desktop {
        padding: 0px;
        height: auto !important;
    }
}

.patientName {
    font-weight: 700;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0%;
    text-transform: none;
    color: var(--brand-indigo);
    padding-bottom: 5px;
    font-family: typography.$font-mont;
    font-style: Bold;

    @include breakpoints.desktop {
        font-weight: 700;
        font-size: 20px;
        line-height: 140%;
        letter-spacing: 0%;
    } 
}

.patientInfo {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0%;
    color: var(--brand-indigo);
    padding-bottom: 5px;
    inline-size: 110%;
    overflow-wrap: anywhere;
    word-break: break-word;

    @include breakpoints.desktop {
        inline-size: initial;
        font-style: normal;
        font-size: 20px;
    }
}

.patientProfile {
    padding: 5% 0px;
    @include breakpoints.desktop {
        padding-left: 10px;
    }
    img {
        width:40px;
        height: 40px;
        @include breakpoints.desktop {
            width: 44px;
            height: 44px;
        }
    }
}

.patientInfoPadding {
   padding: 18px 0px;
}

.saveTime {
    font-weight: 600;
    font-size: 15px;
    line-height: 150%;
    text-align: left;
    letter-spacing: 0.12em;
    text-transform: uppercase; 
    color: var(--black);
    margin-bottom: 30px;
    height: 40px;
    @include breakpoints.desktop {
        height: auto;
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
    }
}

.saveTimeIcon {
    width: 30px;
    margin-left: 7px;
    @include breakpoints.desktop {
        width: auto;
        margin-left: 0px;
    }
}

.checkButton {
    button {
        font-weight: 400;
        font-size: 20px;
        line-height: 150%;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--white);        
        width: 90%;
        left: 5%;
        position: absolute;
        right: 20px;
        @include breakpoints.desktop {
            width:95%;
            position: initial;
            left: 0px;
            right: 0px;
            font-size: 18px;
        }
    }
}

.checkInPad {
    padding: 20px 25px;
    height: 140px;
    @include breakpoints.desktop {
        padding: 3% 0 2% 2%;
        height: 150px;
    }
}


.contentBoxV2 {
    background: var(--white);
    box-shadow: none;
    padding: 0px;
    float: left;
    margin-bottom: 10px;
    height: auto;
    border-radius: 20px;
    margin-left: 10px;
    width: 95%;
    @include breakpoints.desktop {
        width: 100%;
        margin: 15px 0px;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
      }
}

.insCheck {
    width: calc(100% - calc(2 * #{var(--card-gutter-width)}));
    margin: 0 auto;
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-size: 14px;
}

.formContainer {
    @include breakpoints.desktop {
        max-width: calc(var(--max-desktop-width) + (2 * var(--card-gutter-width)));
        margin: 0 auto;
        font-size: 14px;
    }
}

.contentLeftV2 {
    width: 15%;
    float: left;
    .avatar {
        @include breakpoints.desktop {
            margin: 6% 0px;
            height: 48px;
            width: 48px;
        }
    }
    @include breakpoints.desktop {
        width: 20%;
        margin: 3% 0px;
        padding-left: 10px;
    }
    @include breakpoints.desktop-medium {
        width: 20%;
        margin: 3% 0px;
        padding-left: 10px;
    }
    @include breakpoints.desktop-large {
        width: 15%;
        margin: 3% 0px;
        padding-left: 10px;
    }
  }
  
.contentRightV2 {
    width: 80%;
    float: left;
    margin-left: 12px;
    @include breakpoints.desktop {
        width:80%;
    }
}

.patientProfileV2 {
    img {
        width:40px;
        height: 40px;
        margin-top: 20px;
        @include breakpoints.desktop {
            width: 44px;
            height: 44px;
        }
    }
}

.buttonContainerV2 {
    text-align: center;
    margin-top: 20px;
    color: var(--white);
    button {
        border: 2px solid var(--blue-01);
        width: 90%;
        letter-spacing: 0.12em;
        font-size: 20px;
        background-color: var(--brand-indigo);
        border-radius: 20px;
        text-transform: none;;
        @include breakpoints.desktop {
            width: 100%;
            font-size: 1.125rem;
        }
    }
}

.patientDetails {
    margin-left: 8px;
    padding: 4px 0;
    @include breakpoints.desktop {
        margin: 0;
        padding: 0;
    }
}

.labelStyle{
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
}
